import { PortalRootName } from "../PortalRootName";
/** The ID prefix that ensures non-overlapping IDs with other things that might be on the page. */ var KAGGLE_PORTAL_ROOT_PREFIX = "kaggle-portal-root";
/**
 * Formats the full ID for portal root containers.
 * Since some cases require rendering to specific locations in the React tree, this ensures unique IDs.
 */ export var getPortalRootId = function() {
    var rootName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PortalRootName.GLOBAL;
    return "".concat(KAGGLE_PORTAL_ROOT_PREFIX, "-").concat(rootName);
};
